import { Injectable, inject } from '@angular/core';
import { NotificationService, NotificationServiceInjector } from '@next/core-lib/notification';
import { createEffect } from '@ngrx/effects';

import { map } from 'rxjs/operators';

import { CropFieldEvents } from '../../models';
import { SyncCropFieldsReadyReceived } from '../actions/crop-field.actions';

@Injectable()
export class CropFieldNotificationEffects {
  private readonly notification = inject<NotificationService>(NotificationServiceInjector);

  soilAnalysisLinkedSuccess$ = createEffect(() =>
    this.notification
      .on<{
        CustomerId: number;
        SearchYear: number;
        ExternalId: string;
        Succeeded: boolean;
        ExternalCropFieldSource: string;
        ErrorCode?: string[];
      }>(CropFieldEvents.syncCropFieldsReady)
      .pipe(
        map((event) => {
          if (typeof event === 'string') {
            const parsedEvent = JSON.parse(event);
            return {
              searchYear: parsedEvent.SearchYear,
              externalId: parsedEvent.ExternalId,
              externalCropFieldSource: parsedEvent.ExternalCropFieldSource,
              succeeded: parsedEvent.Succeeded,
              errorCode: parsedEvent.ErrorCode,
            };
          }
          return {
            searchYear: event.SearchYear,
            externalId: event.ExternalId,
            externalCropFieldSource: event.ExternalCropFieldSource,
            succeeded: event.Succeeded,
            errorCode: event.ErrorCode,
          };
        }),
        map(
          (payload) =>
            new SyncCropFieldsReadyReceived(
              payload.searchYear,
              payload.externalId,
              payload.externalCropFieldSource,
              payload.succeeded,
              payload.errorCode,
            ),
        ),
      ),
  );
}
